import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import axiosConn from "config/axiosConn";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import Helper from "../helper/Common_Helper";

function LifiCalender() {
  const [eventsData, setEventsData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    getThemes();
  }, []);

  const getThemes = async () => {
    try {
      let response = await axiosConn("post", "get-theme-calender", {
        event_date: true,
      });
      if (response.data.status === "success") {
        const currentDate = new Date(); 
        const formattedEvents = response.data.result
          .filter((event) => new Date(event.event_date) <= currentDate) 
          .map((event) => ({
            title: event.event_name,
            start: event.event_date,
            extendedProps: {
              theme_name: event.theme_name,
              subtheme_name: event.sub_themes[0],
            },
          }));
        setEventsData(formattedEvents);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const renderEventContent = (eventInfo) => {
    const { event } = eventInfo;
    return (
      <div
        style={{
          backgroundColor: "#017ef6",
          borderColor: "#017ef6",
          padding: "6px",
          borderRadius: "8px",
          fontSize: "16px",
          textAlign: "center",
          overflow: "hidden",
          color: "#fff",
        }}
      >
        <i>{event.title}</i>
      </div>
    );
  };

  const handleEventClick = (clickInfo) => {
    setSelectedEvent(clickInfo.event);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);
  const handleEventCreate = async (newEvent) => {
    const currentDate = new Date(); 
    const eventDate = new Date(newEvent.event_date); 
    if (eventDate > currentDate) {
      alert("Event cannot be created with a future date!");
      return;
    }

    try {
      await axiosConn("post", "create-event-endpoint", newEvent);
      alert("Event created successfully!");
    } catch (error) {
      // console.log("Error creating event:", error);
    }
  };

  return (
    <>
      <section className="scholdashbrdSec pb-5">
        <div
          className="schlDashbrdRgt"
          style={{ float: "none", margin: "auto" }}
        >
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="card-user pageContainer">
                <div className="sliderInrHdng" style={{ position: "static" }}>
                  <h2>
                    Life <span className="hdngBrkr">Calendar</span>
                  </h2>
                </div>
                <div className="viewThemeDiv">
                  <FullCalendar
                    plugins={[dayGridPlugin]}
                    initialView="dayGridMonth"
                    weekends={true}
                    events={eventsData}
                    eventContent={renderEventContent}
                    eventClick={handleEventClick}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Event Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {selectedEvent && (
            <>
              <p>
                <strong>Name of the event :</strong> {selectedEvent.title}
              </p>
              <p>
                <strong>Theme:</strong> {selectedEvent.extendedProps.theme_name}
              </p>
              <p>
                <strong>Subtheme:</strong>{" "}
                {selectedEvent.extendedProps.subtheme_name}
              </p>
              <p>
                <strong>Date & Time :</strong>{" "}
                {Helper.formatDate(selectedEvent.start)}
              </p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default LifiCalender;

